import { CurrencyAmount, Token } from '@kodiak-finance/sdk-core'
import { ButtonError } from 'components/Button'
import { LightCard, OutlineCard } from 'components/Card'
import Column, { AutoColumn } from 'components/Column'
import Row, { RowBetween } from 'components/Row'
import ConfirmationTransactionStep, {
  ConfirmationTransactionStepProps,
} from 'components/StepLine/common/ConfirmationTransactionStep'
import { useMemo } from 'react'
import { AlertTriangle } from 'react-feather'
import { Text } from 'rebass'
import styled, { useTheme } from 'styled-components'
import { opacify } from 'theme/utils'

const WarningCard = styled(OutlineCard)<{ color: string }>`
  padding: 12px;
  border: 1px solid ${({ color }) => opacify(24, color)};
  border-radius: 4px;
`

type CancelRedeemStepProps = {
  next: () => void
  onCancel: () => void
  xKdkAmount: CurrencyAmount<Token>
} & Omit<ConfirmationTransactionStepProps, 'children' | 'onConfirm'>

const CancelRedeemStep = ({ next, onCancel, xKdkAmount, ...rest }: CancelRedeemStepProps) => {
  const theme = useTheme()
  const warningColor = useMemo(() => theme.deprecated_error, [theme.deprecated_error])

  return (
    <ConfirmationTransactionStep onConfirm={next} {...rest}>
      <Column gap="10px" width="100%">
        <LightCard>
          <AutoColumn gap="6px">
            <RowBetween>
              <Text color={theme.textSecondary} fontSize={14}>
                You will receive
              </Text>
              <Text color={theme.textPrimary} fontSize={16}>
                {xKdkAmount.toSignificant(6)} {xKdkAmount.currency.symbol}
              </Text>
            </RowBetween>
          </AutoColumn>
        </LightCard>
        <WarningCard color={warningColor}>
          <Row gap="8px" align="flex-start">
            <AlertTriangle size={24} color={warningColor} />
            <Text color={theme.textSecondary} fontSize={13}>
              Canceling returns your xKDK and forfeits the redemption progress. You will need to start a new redeem to
              receive KDK.
            </Text>
          </Row>
        </WarningCard>
        <ButtonError onClick={onCancel}>Cancel redeem</ButtonError>
      </Column>
    </ConfirmationTransactionStep>
  )
}

export default CancelRedeemStep
